import React from 'react'
import Icon from 'components/Shared/Icon'

interface AuditSuccessMessageProps {
  type:
    | 'nested-lists'
    | 'orphaned-screens'
    | 'lottie-components'
    | 'legacy-components'
    | 'private-components'
    | 'rn-version-mismatch'
}

const AuditSuccessMessage: React.FC<AuditSuccessMessageProps> = ({
  type = 'nested-lists',
}) => {
  const messages = {
    'nested-lists': {
      title: 'No Nested Lists Found',
      description:
        'Great job! Your app has no nested lists that could impact performance.',
      icon: 'check-circle',
    },
    'orphaned-screens': {
      title: 'No Orphaned Screens',
      description:
        'Excellent! All your screens are properly connected in the navigation flow.',
      icon: 'check-circle',
    },
    'lottie-components': {
      title: 'No Lottie Components',
      description:
        'Fantastic! Your app currently does not include any Lottie animations that could impact performance.',
      icon: 'check-circle',
    },
    'legacy-components': {
      title: 'No Legacy Components',
      description:
        'Great! Your app does not use any legacy components that might need updating.',
      icon: 'check-circle',
    },
    'private-components': {
      title: 'No Private Components',
      description:
        'Perfect! Your app does not use any private components that require special handling.',
      icon: 'check-circle',
    },
    'rn-version-mismatch': {
      title: 'No Version Mismatches',
      description:
        'Excellent! All your components are using compatible React Native versions.',
      icon: 'check-circle',
    },
  }

  const { title, description, icon } = messages[type]

  return (
    <div className="audit-success-message">
      <div className="success-content">
        <div className="success-icon">
          <Icon type={icon} />
        </div>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default AuditSuccessMessage
